import axios from "axios";

const LOGIN_PATH = "/login";
let isRedirectingToLogin = false;
let axiosInterceptorId = null;

const clearAuthSession = () => {
  try {
    localStorage.removeItem("AuthToken");
    localStorage.removeItem("couponVerified");
  } catch (error) {
    console.error("Unable to clear auth session:", error);
  }
};

export const redirectToLoginOnUnauthorized = () => {
  if (typeof window === "undefined") {
    return;
  }

  clearAuthSession();

  if (window.location.pathname === LOGIN_PATH || isRedirectingToLogin) {
    return;
  }

  isRedirectingToLogin = true;
  const redirectFrom = `${window.location.pathname}${window.location.search}`;
  window.location.replace(
    `${LOGIN_PATH}?redirect=${encodeURIComponent(redirectFrom)}`
  );
};

const installFetchUnauthorizedHandler = () => {
  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }

  if (window.fetch.__unauthorizedRedirectInstalled) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  const fetchWithUnauthorizedRedirect = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401) {
      redirectToLoginOnUnauthorized();
    }

    return response;
  };

  fetchWithUnauthorizedRedirect.__unauthorizedRedirectInstalled = true;
  window.fetch = fetchWithUnauthorizedRedirect;
};

export const installUnauthorizedRedirectHandler = () => {
  installFetchUnauthorizedHandler();

  if (axiosInterceptorId !== null) {
    return;
  }

  axiosInterceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        redirectToLoginOnUnauthorized();
      }

      return Promise.reject(error);
    }
  );
};
